import React from "react";
import { Reveal } from "./Reveal";
import CtaButton from "./CtaButton";

const FinalCTA = () => {
  return (
    <section data-testid="final-cta-section" className="border-t border-white/10 relative overflow-hidden">
      <div className="absolute inset-0 -z-10">
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 h-[300px] w-[600px] bg-cyan-500/10 blur-[120px] rounded-full" />
      </div>
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-28 md:py-40 text-center">
        <Reveal>
          <p className="font-mono text-xs font-bold uppercase tracking-[0.2em] text-cyan-400 mb-6">
            / Ready when you are
          </p>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-light tracking-tighter text-white max-w-3xl mx-auto leading-[1.05]">
            Open the terminal and roll your first call.
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-6 text-lg text-zinc-400 max-w-xl mx-auto leading-relaxed">
            You've seen how it works. Launch ROLL.OPS, sign in with Google, and put
            your covered call strategy on autopilot.
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            <CtaButton
              ctaId="final-primary-cta"
              label="Open ROLL.OPS"
              location="final-cta"
              className="px-8 py-4 text-base"
            >
              Open ROLL.OPS
            </CtaButton>
            <a
              href="#tutorial"
              data-testid="final-secondary-cta"
              className="inline-flex items-center justify-center px-8 py-4 text-sm font-medium text-white border border-white/20 hover:bg-white/5 hover:border-white/40 transition-all duration-300"
            >
              Re-read the tutorial
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default FinalCTA;
